import React from "react";
import { useGetSNSFollowers } from "../../utils/useSNS";
import SNSFollowers from "./SNSFollowers";

type Props = {
  id: string;
  instagramLink?: string;
  youtubeLink?: string;
  twitchLink?: string;
};
const SNSFollowersContainer: React.FC<Props> = ({
  id,
  instagramLink,
  youtubeLink,
  twitchLink,
}) => {
  const { followersData, isLoading } = useGetSNSFollowers(id);

  if (isLoading || followersData) {
    return (
      <SNSFollowers
        isLoading={isLoading}
        followersData={followersData}
        instagramLink={instagramLink}
        youtubeLink={youtubeLink}
        twitchLink={twitchLink}
      />
    );
  } else {
    return null;
  }
};

export default SNSFollowersContainer;
